import styled from 'styled-components';
import { TextStyles } from '@/constants';
import Typography from '@/components/Typography';

export const NoParcelsContainer = styled.div`
  padding: ${({ theme }) => theme.spacing[16]};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  word-break: break-word;
`;

export const NoParcelsText = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  color: ${({ theme }) => theme.colors.inactiveBlack};
  margin-top: ${({ theme }) => theme.spacing[8]};
`;

export const NoParcelsAddedYetWrapper = styled.div`
  margin: ${({ theme }) => `${theme.spacing[20]} -${theme.spacing[20]} -${theme.spacing[20]}`};
  padding: ${({ theme }) => theme.spacing[20]};
  background-color: ${({ theme }) => theme.colors.pageBackground};

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    margin: 0;
    padding: 0;
    background-color: unset;
  }
`;
